import { Property } from 'api/clients/PropertyClient'
import cx from 'classnames'
import ExistingPropertyActionItem from 'common/PropertyActions/ExistingPropertyActionItem'
import { Button } from 'components/Button'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { useHandbookReadOnlyUser } from 'hooks/useHandbookReadOnlyUser'
import { PropertyFinder } from '../PropertyFinder/PropertyFinder'
import Styles from './PropertyPicker.module.scss'

const PropertyPicker = ({
  triggerClassName = '',
  selectedProperty,
  onPropertySelected,
  properties,
  isDisabled = false,
}: {
  triggerClassName?: string
  properties: Property[]
  selectedProperty: Property
  onPropertySelected: (property: Property) => void
  withExtraProperties?: Property[]
  isDisabled?: boolean
}) => {
  const { isReadOnlyUser } = useHandbookReadOnlyUser()

  return (
    <DropdownTrigger placement="bottom-start" popoverClassName={Styles.popover} noPressed>
      <Button
        variant="secondaryGrey"
        size="lg"
        withChevron="down"
        className={cx(Styles.trigger, triggerClassName)}
        isDisabled={isReadOnlyUser || isDisabled}
      >
        <ExistingPropertyActionItem property={selectedProperty} className={Styles.selectedProperty} />
      </Button>
      {(close) => (
        <PropertyFinder
          onPropertySelected={(property: Property) => {
            onPropertySelected(property)
            close()
          }}
          properties={properties}
          selectedProperty={selectedProperty}
          className={Styles.picker}
        />
      )}
    </DropdownTrigger>
  )
}

export { PropertyPicker }
